module.exports = __webpack_public_path__ + "img/lead-airport.6e5184a7.svg";